export default class Hidash {

  static getSearchParams=(key:string)=>{
    const queryString: string = window.location.search;
    const urlParams: URLSearchParams = new URLSearchParams(queryString);
    const value: string | null = urlParams.get(key);
    return value
  }

}
